import React from "react";
import "./SocialMedia.scss";
import { socialMediaLinks } from "../../portfolio";

export default function SocialMedia({ trackClick }) {
  if (!socialMediaLinks.display) {
    return null;
  }

  // ✅ GA helper
  const handleClick = (label) => {
    if (trackClick) {
      trackClick(label);
    } else if (window.gtag) {
      window.gtag("event", "social_media_click", {
        event_category: "engagement",
        event_label: label,
      });
    }
  };

  // Map of links to icon classes and SCSS classes
  const links = [
    { key: "github", icon: "fab fa-github", className: "github", label: "GitHub" },
    { key: "linkedin", icon: "fab fa-linkedin-in", className: "linkedin", label: "LinkedIn" },
    { key: "gmail", icon: "fas fa-envelope", className: "google", label: "Email" },
    { key: "gitlab", icon: "fab fa-gitlab", className: "gitlab", label: "GitLab" },
    { key: "facebook", icon: "fab fa-facebook-f", className: "facebook", label: "Facebook" },
    { key: "instagram", icon: "fab fa-instagram", className: "instagram", label: "Instagram" },
    { key: "twitter", icon: "fab fa-twitter", className: "twitter", label: "Twitter" },
    { key: "medium", icon: "fab fa-medium", className: "medium", label: "Medium" },
    { key: "stackoverflow", icon: "fab fa-stack-overflow", className: "stack-overflow", label: "StackOverflow" },
    { key: "kaggle", icon: "fab fa-kaggle", className: "kaggle", label: "Kaggle" },
  ];

  return (
    <div className="social-media-div">
      {links.map(
        ({ key, icon, className, label }) =>
          socialMediaLinks[key] && (
            <a
              key={key}
              href={key === "gmail" ? `mailto:${socialMediaLinks[key]}` : socialMediaLinks[key]}
              className={`icon-button ${className}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => handleClick(label)}
            >
              <i className={icon}></i>
              <span></span>
            </a>
          )
      )}
    </div>
  );
}